<template>
  <div class="d-inline">
    <!-- <v-tooltip slot="append" max-width="300px" min-width="200px" bottom> -->
    <v-btn color="info"
           small
           outline
           @click="downloadNotaPDF"
           target="_blank"
           v-if="showDownloadBtn"
           :disabled="loading"
           slot="activator"
           :loading="loading"
           >
           NOTA
    </v-btn>
      <!-- <span>
        {{ $t('addFiscalDataWarning') }}
      </span> -->
    <!-- </v-tooltip> -->

    <Notalabel
      v-if="showDownloadBtn"
      v-show="false"
      :shipment="shipment"
      :is-app-logo="isAppLogo"
      :terms-conditions-link="termsConditionsLink"
      :app-logo="appLogo"
      ref="notalabel"
    ></Notalabel>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import Shipment from '@/client/shipment'
import Notalabel from '@/components/shipments/notalabel'

export default {
  name: 'DownloadNotaLabelBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    },
    fiscalDatum: {
      type: Object,
      required: false
    },
    labelFormat: {
      type: String,
      required: true
    },
    termsConditionsLink: {
      type: String,
      required: false
    },
    appLogo: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      isAppLogo: true,
      loading: false,
      buttonClicked: false
    }
  },

  components: {
    Notalabel
  },

  computed: {

    showDownloadBtn () {
      return this.shipment.step === 'confirmed' &&
        ( this.$auth.isDev() || this.$auth.isOper() || this.$auth.isAdmin() ) &&
        (this.shipment.status === 'success' || (this.shipment.status === 'canceled' && this.$auth.isDev())) &&
        !!this.shipment.generated_label
    }
  },

  methods: {
    async downloadNotaPDF () {
      this.loading = true
      this.buttonClicked = true
      //working config with image
      var opt = {
        // margin:      (this.labelFormat == 'letter' ? [50, 20, 20, 20] : [10, 3, 3, 0]),
        margin:      [0, 0, 3, 0],
        enableLinks: true,
        filename:    `${ this.shipment.id }-${ this.shipment.rate.service.carrier.provider.name.replace(' ', '-') }-label.pdf`,
        html2canvas: { useCORS: true },
        image: { type: "jpeg", quality: 1 },
        // jsPDF: { unit: 'mm', format: (this.labelFormat == 'letter' ? 'letter' : [263.0, 78.0]), orientation: 'portrait'},
        jsPDF: { unit: 'mm', format: 'A6', orientation: 'portrait'},
        // pagebreak: { mode: 'avoid-all', before: '#page2el' }
      };

      try {
        //get app logo as base 64 encoding from backend 
        // var dataImg = await this.getAppLogo()

        var notaLabel = this.$refs.notalabel.$el.innerHTML
        html2pdf().set(opt).from(notaLabel).save();

        // if (dataImg && dataImg.length > 30) {
        //   // create pdf from template and add app logo 
          // html2pdf().from(notaLabel).set(opt).toPdf().get('pdf').then(function (pdf) {
          //   pdf.addImage(dataImg, "PNG", 95, 20, 20, 20);
          // })
          // .save();
        // } else {
          // add code to insert company name if logo not present
          // this.isAppLogo = false
          // notaLabel = this.$refs.notalabel.$el.innerHTML
          // html2pdf().from(notaLabel).set(opt).save();
        // }

      } catch (err) {
        // console.log('err', err)
        html2pdf().set(opt).from(notaLabel).save();
      }

      this.loading = false
    },

    async getAppLogo () {
      try {
        const data = await Shipment.getAppLogo()
        return data.text()
      } catch (err) {
        this.handleBlobErr(err)
      }
    },

    handleBlobErr (err) {
      const self = this
      if (err.response) {
        const blob = err.response.data
        const reader = new FileReader()

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          self.handleErr({ response: { data: JSON.parse(text) } })
        })

        // Start reading the blob as text.
        reader.readAsText(blob)
      } else {
        this.handleErr(err)
      }
    },

    isFiscalDataPresent () {
      return (!!this.fiscalDatum.business_name && !!this.fiscalDatum.country_id)
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
